// Import Types
import type {
    DataWithPaging,
    KnowledgeCenterAdminArticle,
    KnowledgeCenterAdminArticleDetails,
    KnowledgeCenterAdminArticleListItem,
    KnowledgeCenterArticleAPIModel,
    KnowledgeCenterHomeAPIModel,
    KnowledgeCenterNavigationItemAPIModel,
    KnowledgeCenterSearchAPIModel,
    KnowledgeCenterSearchRequestParams,
} from 'types';
// Import Helpers
import { generateCleanUrlParams } from 'services/Helpers';
// Import Configs
import { CRMRequestService, getCancelableRequest, postCancelableRequest } from './http.config';

const KnowledgeCenterHttpService = {
    getKnowledgeCenterHomePageData: () => {
        return getCancelableRequest<KnowledgeCenterHomeAPIModel>({
            requestService: CRMRequestService,
            endpointPath: () => '/KnowledgeCenter/GetPageData',
        });
    },
    getKnowledgeCenterNavigationData: () => {
        return getCancelableRequest<KnowledgeCenterNavigationItemAPIModel[]>({
            requestService: CRMRequestService,
            endpointPath: () => '/KnowledgeCenter/GetNavigation',
        });
    },
    getKnowledgeCenterArticleData: () => {
        return getCancelableRequest<KnowledgeCenterArticleAPIModel>({
            requestService: CRMRequestService,
            endpointPath: ({ articleId }) => `/KnowledgeCenter/GetArticle${generateCleanUrlParams({ articleId })}`,
        });
    },
    getAdminArticleList: () => {
        return postCancelableRequest<DataWithPaging<KnowledgeCenterAdminArticleListItem>>({
            requestService: CRMRequestService,
            endpointPath: () => '/Admin/KnowledgeCenter/List',
        });
    },
    getAdminArticle: () => {
        return getCancelableRequest<KnowledgeCenterAdminArticleDetails>({
            requestService: CRMRequestService,
            endpointPath: ({ articleId, isClone }) =>
                `/Admin/KnowledgeCenter/Get?articleId=${articleId}&isClone=${isClone}`,
        });
    },
    createAdminArticle: () => {
        return postCancelableRequest<KnowledgeCenterAdminArticle>({
            requestService: CRMRequestService,
            endpointPath: () => '/Admin/KnowledgeCenter/Create',
        });
    },
    updateAdminArticle: () => {
        return postCancelableRequest<KnowledgeCenterAdminArticle>({
            requestService: CRMRequestService,
            endpointPath: () => '/Admin/KnowledgeCenter/Update',
        });
    },
    deleteAdminArticle: () => {
        return postCancelableRequest({
            requestService: CRMRequestService,
            endpointPath: ({ articleId }) => `/Admin/KnowledgeCenter/Delete?id=${articleId}`,
        });
    },
    publishAdminArticle: () => {
        return postCancelableRequest({
            requestService: CRMRequestService,
            endpointPath: ({ articleId }) => `/Admin/KnowledgeCenter/Publish?id=${articleId}`,
        });
    },
    unpublishAdminArticle: () => {
        return postCancelableRequest({
            requestService: CRMRequestService,
            endpointPath: ({ articleId }) => `/Admin/KnowledgeCenter/Unpublish?id=${articleId}`,
        });
    },
    searchKnowledgeCenter: () => {
        return getCancelableRequest<KnowledgeCenterSearchAPIModel, KnowledgeCenterSearchRequestParams>({
            requestService: CRMRequestService,
            endpointPath: (params) => `/KnowledgeCenter/Search${generateCleanUrlParams(params)}`,
        });
    },
};

export default KnowledgeCenterHttpService;
